const colorPicker = {
    add: 'SELECT',
    change: 'CHANGE',
    close: 'CANCEL'
};

export default colorPicker;